import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Disable smooth scrolling temporarily
        const originalBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        
        // Scroll to top instantly
        window.scrollTo(0, 0);
        
        // Restore original scroll behavior after a brief delay
        setTimeout(() => {
            document.documentElement.style.scrollBehavior = originalBehavior;
        }, 100);
        
    }, [pathname]);

    return null;
};

export default ScrollToTop;